import Header from '../../components/header';
import Balance from './balance';
import Buttons from './buttons';
import Transactions from './transactions';
import CashOutBlocked from './cashout_blocked';
import Slider from './slider';
import Freeplays from './freeplays';
import Halloween from './halloween';


export default () => (
    <>
        <Header />
        <div className="main">
            <Balance />
            <Buttons />
            <CashOutBlocked />
            <Slider />
            <Transactions />
        </div>
    </>
)